/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.page_size = this.dataset.pageSize;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      if (!base.dataset.nextUrl) {
        base.hide();
        return;
      }
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          base.loadProducts();
        }
      }, {
        rootMargin: '0px 0px 400px 0px'
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        isInfinite = base.classList.contains('pagination-type--infinite'),
        url;

      if (base.getAttribute('loading')) {
        return;
      }

      if (isInfinite) {
        url = base.dataset.nextUrl;
        if (!url) {
          base.hide();
          return;
        }
        delete base.dataset.nextUrl;
      } else {
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
        base.i++;
      }

      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        })
        .catch(function () {
          if (isInfinite) {
            base.dataset.nextUrl = url;
          }
          base.removeAttribute('loading');
        });
    }
    renderProducts(html, url) {
      let base = this,
        parsed = new DOMParser().parseFromString(html, 'text/html'),
        grid_to_replace = parsed.getElementById('product-grid'),
        isInfinite = base.classList.contains('pagination-type--infinite');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }

      if (isInfinite) {
        const nextPagination = parsed.getElementById('ProductGridContainer')?.querySelector('pagination-theme');
        const nextUrl = nextPagination?.dataset.nextUrl;
        if (nextUrl) {
          base.dataset.nextUrl = nextUrl;
        }
      }

      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }
      if (isInfinite && !base.dataset.nextUrl) {
        base.hide();
      } else if (!isInfinite && products.length < this.page_size) {
        base.hide();
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
            base.queueNextPage();
          }
        });
      } else {
        base.removeAttribute('loading');
        if (typeof StampedFn !== "undefined" && typeof StampedFn.loadBadges !== "undefined") {
          StampedFn.loadBadges();
        }
        base.queueNextPage();
      }
    }
    queueNextPage() {
      if (!this.classList.contains('pagination-type--infinite') || !this.observer || !this.dataset.nextUrl) {
        return;
      }
      this.observer.unobserve(this);
      this.observer.observe(this);
    }
    hide() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.hidden = true;
      } else if (this.button) {
        this.button.style.display = 'none';
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}